import React, { createContext, useContext } from 'react';

const FilterContext = createContext();

const Provider = FilterContext.Provider;

const EMPTY_FUNCTION = () => () => ({});

const useFilterContext = (name) => {
  const { filters, setFilter = EMPTY_FUNCTION } = useContext(FilterContext);
  return [filters[name]?.value, setFilter(name)];
};

const withFilterContext = (Component, { name, ...props }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [filterValue, setFilterValue] = useFilterContext(name);
  return (
    <Component
      {...props}
      filterValue={filterValue}
      setFilterValue={setFilterValue}
    />
  );
};

export { Provider, useFilterContext, withFilterContext };
